import { createContext } from "react";
import { Assessment, Quiz } from "sj-ui-toolkit/src/api/types/quizTypes";

export const VideoContext = createContext({
  // Lesson state
  inLessonMode: false as boolean,
  onLessonClick: () => {},
  isLessonComplete: false as boolean,
  onLessonFinish: () => {},
  nextLesson: null as number | null,
  exerciseOnly: false as boolean,

  // Quiz state
  inQuizMode: false as boolean,
  setInQuizMode: (_inQuizMode: boolean) => {},
  quiz: {
    assessment: {
      id: 0,
      answersCount: 0,
      questionsCount: 0,
      assessmentScore: 0,
      result: "",
    },
  } as Quiz,
  onQuizTake: async () => {},
  onQuizFinish: (_quizData: Assessment) => {},
  onQuizRetake: async () => {},
  onQuizReview: () => {},

  // Exercise state
  inExerciseMode: false as boolean,
  setInExerciseMode: (_inExerciseMode: boolean) => {},
  onExerciseLaunch: () => {},
  isExercisePassed: false as boolean,
  onExercisePassed: () => {},

  // Tournament state
  tournamentUuid: undefined as string | undefined,
});
